import { Box, BoxProps, Container, createStyles, makeStyles } from '@material-ui/core';
import clsx from 'clsx';
import React from 'react';
import Frayed from 'src/resources/icons/Frayed';

const useStyles = makeStyles(theme =>
    createStyles({
        root: {
            backgroundPosition: 'center',
            backgroundSize: 'cover',
            backgroundRepeat: 'no-repeat',
            backgroundColor: theme.palette.common.white,
        },
        stickyTop: {
            zIndex: theme.zIndex.appBar,
            position: 'sticky',
            top: '0px',
        },
        stickyBottom: {
            zIndex: theme.zIndex.appBar,
            position: 'sticky',
            bottom: '0px',
        },
        spacing: {
            paddingTop: (props: StyleProps) => theme.spacing(props.spacing),
            paddingBottom: (props: StyleProps) => theme.spacing(props.spacing),
        },
        container: {
            overflow: 'hidden',
        },
        frayedBorder: {
            position: 'relative',
        },
        fb: {
            position: 'absolute',
            width: '100%',
            height: '50px',
        },
        fbTop: {
            top: '-25px',
        },
        fbBottom: {
            bottom: '-25px',
        },
    })
);

interface StyleProps {
    spacing: number;
}

export const SPACING_MAP = { none: 0, compact: 1, medium: 2, normal: 3, big: 5, huge: 12, mega: 19 };

interface SectionClasses {
    container?: string;
}
export interface SectionProps extends Omit<BoxProps, 'classes'> {
    sticky?: 'top' | 'bottom';
    maxWidth?: 'xs' | 'sm' | 'md' | 'lg' | 'xl' | false;
    spacing?: keyof typeof SPACING_MAP;
    frayed?: 'top' | 'bottom' | 'both';
    frayedColor?: 'primary' | 'secondary';
    frayedHtmlColor?: string;
    classes?: SectionClasses;
    hiddenOverflow?: boolean;
}

const Section: React.FC<SectionProps> = ({
    children,
    sticky,
    maxWidth,
    spacing = 'normal',
    frayed,
    frayedColor = 'primary',
    frayedHtmlColor,
    classes = {},
    className,
    hiddenOverflow = true,
    ...boxProps
}) => {
    const frayedTop = frayed === 'both' || frayed === 'top';
    const frayedBottom = frayed === 'both' || frayed === 'bottom';

    const sectionClasses = useStyles({ spacing: SPACING_MAP[spacing] });

    const frayedCol = frayedHtmlColor ? { htmlColor: frayedHtmlColor } : { color: frayedColor };

    return (
        <Box
            component="section"
            {...boxProps}
            className={clsx(className, sectionClasses.root, sectionClasses.spacing, {
                [sectionClasses.frayedBorder]: frayed,
                [sectionClasses.stickyTop]: sticky === 'top',
                [sectionClasses.stickyBottom]: sticky === 'bottom',
            })}>
            {frayedTop && <Frayed {...frayedCol} className={clsx(sectionClasses.fb, sectionClasses.fbTop)} />}
            <Container
                className={clsx({ [sectionClasses.container]: hiddenOverflow }, classes.container)}
                maxWidth={maxWidth}>
                {children}
            </Container>
            {frayedBottom && <Frayed {...frayedCol} className={clsx(sectionClasses.fb, sectionClasses.fbBottom)} />}
        </Box>
    );
};

export default Section;
